import Vue from 'vue';
import axios from "axios";
Vue.use(axios);


export default  function convertObjectToCSV(objArray) {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
  let str = '';

  // CSVヘッダを追加
  for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let key in array[i]) {
          if (line !== '') line += ',';
          line += key;
      }
      str += line + '\r\n';
      break;
  }

  // データ行を追加
  for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let key in array[i]) {
          if (line !== '') line += ',';
          line += array[i][key];
      }
      str += line + '\r\n';
  }
  return str;
}
